import React from 'react';

interface MegaphoneWithSparklesIconProps {
  size?: number;
}

const MegaphoneWithSparklesIcon: React.FC<MegaphoneWithSparklesIconProps> = ({
  size = 28,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Megaphone body */}
      <g transform="translate(-1.5, -1.5) scale(1.3)">
        <path
          d="M13.5 3.5V12.5C13.5 12.5 10.5 11 8 11H5C4.2 11 3.5 10.3 3.5 9.5V6.5C3.5 5.7 4.2 5 5 5H8C10.5 5 13.5 3.5 13.5 3.5Z"
          stroke="var(--primary, #17c964)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 11V14C5.5 14.6 5.9 15 6.5 15H7.5C8.1 15 8.5 14.6 8.5 14V11"
          stroke="var(--primary, #17c964)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5 6.5C16.1 7.1 16.5 7.8 16.5 8C16.5 8.2 16.1 8.9 15.5 9.5"
          stroke="var(--primary, #17c964)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      {/* Large gold sparkle - top right */}
      <path
        d="M24 0C24 0 24.7 2.5 25 3.3C25.3 4.1 27.8 4.7 27.8 4.7C27.8 4.7 25.3 5.3 25 6.1C24.7 6.9 24 9.4 24 9.4C24 9.4 23.3 6.9 23 6.1C22.7 5.3 20.2 4.7 20.2 4.7C20.2 4.7 22.7 4.1 23 3.3C23.3 2.5 24 0 24 0Z"
        fill="#f2d093"
      />
      {/* Large blue sparkle - right middle */}
      <path
        d="M22.5 10C22.5 10 23 12 23.2 12.6C23.4 13.2 25.4 13.7 25.4 13.7C25.4 13.7 23.4 14.2 23.2 14.8C23 15.4 22.5 17.4 22.5 17.4C22.5 17.4 22 15.4 21.8 14.8C21.6 14.2 19.6 13.7 19.6 13.7C19.6 13.7 21.6 13.2 21.8 12.6C22 12 22.5 10 22.5 10Z"
        fill="#3b82f6"
      />
      {/* Medium purple sparkle - upper right */}
      <path
        d="M18.5 0.5C18.5 0.5 18.85 1.8 19 2.2C19.15 2.6 20.4 2.9 20.4 2.9C20.4 2.9 19.15 3.2 19 3.6C18.85 4 18.5 5.3 18.5 5.3C18.5 5.3 18.15 4 18 3.6C17.85 3.2 16.6 2.9 16.6 2.9C16.6 2.9 17.85 2.6 18 2.2C18.15 1.8 18.5 0.5 18.5 0.5Z"
        fill="#a855f7"
      />
      {/* Medium green sparkle - far right */}
      <path
        d="M28.5 8C28.5 8 28.8 9.1 28.95 9.5C29.1 9.9 30.2 10.2 30.2 10.2C30.2 10.2 29.1 10.5 28.95 10.9C28.8 11.3 28.5 12.4 28.5 12.4C28.5 12.4 28.2 11.3 28.05 10.9C27.9 10.5 26.8 10.2 26.8 10.2C26.8 10.2 27.9 9.9 28.05 9.5C28.2 9.1 28.5 8 28.5 8Z"
        fill="#17c964"
      />
      {/* Small pink sparkle - lower right */}
      <path
        d="M27 16C27 16 27.25 16.9 27.35 17.2C27.45 17.5 28.3 17.7 28.3 17.7C28.3 17.7 27.45 17.9 27.35 18.2C27.25 18.5 27 19.4 27 19.4C27 19.4 26.75 18.5 26.65 18.2C26.55 17.9 25.7 17.7 25.7 17.7C25.7 17.7 26.55 17.5 26.65 17.2C26.75 16.9 27 16 27 16Z"
        fill="#ec4899"
      />
      {/* Small cyan sparkle - top */}
      <path
        d="M30 3C30 3 30.2 3.7 30.28 3.9C30.36 4.1 31 4.3 31 4.3C31 4.3 30.36 4.5 30.28 4.7C30.2 4.9 30 5.6 30 5.6C30 5.6 29.8 4.9 29.72 4.7C29.64 4.5 29 4.3 29 4.3C29 4.3 29.64 4.1 29.72 3.9C29.8 3.7 30 3 30 3Z"
        fill="#06b6d4"
      />
      {/* Tiny gold sparkle - high */}
      <path
        d="M16.5 3C16.5 3 16.65 3.55 16.72 3.7C16.79 3.85 17.35 4 17.35 4C17.35 4 16.79 4.15 16.72 4.3C16.65 4.45 16.5 5 16.5 5C16.5 5 16.35 4.45 16.28 4.3C16.21 4.15 15.65 4 15.65 4C15.65 4 16.21 3.85 16.28 3.7C16.35 3.55 16.5 3 16.5 3Z"
        fill="#f2d093"
      />
    </svg>
  );
};

export default MegaphoneWithSparklesIcon;
